// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2NxEd","content-link-wrapper":"_20f-n","settings-link":"_2mwxJ","retry-subscription-btn":"_2ZL_l","cross-icon":"_2S3jY","alert-dot":"_3s1F9"};